<template>
  <div class="content-loader" >
      <div id="loader2"></div>
      <div class="cssload-dots">
        <div class="cssload-dot"></div>
        <div class="cssload-dot"></div>
        <div class="cssload-dot"></div>
        <div class="cssload-dot"></div>
        <div class="cssload-dot"></div>
      </div>
    </div>
</template>
<script>
export default {
  name: "overlay-general",
  components: { },
  props: {
    loading:{
        default:true,
        type: Boolean
    }
  },
  emits: [],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
  #loader2 {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 150px 0 0 -75px;
  }
</style>